<template>
  <div class="card" @click="selectNewStep(1)">
    <div class="card__statusInformation">
      <div class="statusInformation__icon">
        <img v-if="steps.bank_data" src="../../../public/images/Icon-check.svg" alt="status icon">
        <img v-else src="../../../public/images/pending.svg" alt="status icon">
      </div>
      <div class="statusInformation_textInformation">
        <h2 class="textInformation__title">
          Dados bancários
        </h2>
        <span v-if="steps.bank_data" class="textInformation__subtitle">
          Finalizado
        </span>
        <span v-else class="textInformation__subtitle">
          Pendente
        </span>
      </div>
    </div>
    <div class="card__arrowForward">
      <img src="../../../public/images/arrow-forward.svg" alt="arrow forward">
    </div>
  </div>

  <div class="card" @click="selectNewStep(2)">
    <div class="card__statusInformation">
      <div class="statusInformation__icon">
        <img v-if="steps.personal_data" src="../../../public/images/Icon-check.svg" alt="status icon">
        <img v-else src="../../../public/images/pending.svg" alt="status icon">
      </div>
      <div class="statusInformation_textInformation">
        <h2 class="textInformation__title">
          Informações pessoais
        </h2>
        <span v-if="steps.personal_data" class="textInformation__subtitle">
          Finalizado
        </span>
        <span v-else class="textInformation__subtitle">
          Pendente
        </span>
      </div>
    </div>
    <div class="card__arrowForward">
      <img src="../../../public/images/arrow-forward.svg" alt="arrow forward">
    </div>
  </div>

  <div class="card" @click="selectNewStep(3)">
    <div class="card__statusInformation">
      <div class="statusInformation__icon">
        <img v-if="steps.vehicle_data" src="../../../public/images/Icon-check.svg" alt="status icon">
        <img v-else src="../../../public/images/pending.svg" alt="status icon">
      </div>
      <div class="statusInformation_textInformation">
        <h2 class="textInformation__title">
          Informações do veículo
        </h2>
        <span v-if="steps.vehicle_data" class="textInformation__subtitle">
          Finalizado
        </span>
        <span v-else class="textInformation__subtitle">
          Pendente
        </span>
      </div>
    </div>
    <div class="card__arrowForward">
      <img src="../../../public/images/arrow-forward.svg" alt="arrow forward">
    </div>
  </div>

  <div class="card" @click="selectNewStep(4)">
    <div class="card__statusInformation">
      <div class="statusInformation__icon">
        <img v-if="steps.documents" src="../../../public/images/Icon-check.svg" alt="status icon">
        <img v-else src="../../../public/images/pending.svg" alt="status icon">
      </div>
      <div class="statusInformation_textInformation">
        <h2 class="textInformation__title">
          Documentações
        </h2>
        <span v-if="steps.documents" class="textInformation__subtitle">
          Finalizado
        </span>
        <span v-else class="textInformation__subtitle">
          Pendente
        </span>
      </div>
    </div>
    <div class="card__arrowForward">
      <img src="../../../public/images/arrow-forward.svg" alt="arrow forward">
    </div>
  </div>

  <FooterButton :confirmData="confirmData" :isDisabled="!isAllStepsCompleted"/>
</template>

<script>
import HeaderTitle from '../components/HeaderTitle.vue';
import FooterButton from '../components/FooterButton.vue';
import CardStatus from '../components/CardStatus.vue';

import { useRouter, useRoute } from 'vue-router';
import { useStore } from '../../stores/cadastro.js';
import { onMounted, computed } from 'vue';

export default {
  components: {
    HeaderTitle,
    FooterButton,
    CardStatus,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const title = 'Cadastro';

    onMounted(() => {
      // Pegar o driverId da URL
      const driverId = route.query.driverId;
      console.log("DriverId da URL:", driverId); // Adicione este log

      if (driverId) {
        store.setDriverId(driverId);
        console.log("DriverId definido na store:", store.driverId); // Adicione este log
      } else {
        console.error("DriverId não encontrado na URL");
      }

      store.fetchDriver();
    });


    const steps = computed(() => store.steps);
    const isAllStepsCompleted = computed(() => store.isAllStepsCompleted);
    const driverId = computed(() => store.driverId);

    function selectNewStep(step) {
      if (step === 1) {
        router.push({ name: 'BankDataForm' });
      } else if (step === 2) {
        router.push({ name: 'PersonalDataForm' });
      } else if (step === 3) {
        router.push({ name: 'VehicleFirstForm' });
      } else if (step === 4) {
        router.push({ name: 'DocumentationsFirstForm' });
      }
    }

    function goBack() {
      router.push({ name: 'InitialData' });
    }

    function confirmData() {
      router.push({ name: 'Statements' })
    }

    return {
      title,
      goBack,
      selectNewStep,
      confirmData,
      steps,
      isAllStepsCompleted,
      driverId,
    };
  },
};
</script>
